// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1888":"9859d9af","2502":"976aae30","2932":"a1ae10cb"}[chunkId] + ".chunk.css";
};